import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';
import Stripe from 'stripe';

export interface ApiResponse {
  success: true;
  paymentMethod: Stripe.PaymentMethod;
}

/**
 * React Query hook to fetch all the available usePaymentMethod for the user from stripe
 * @returns ApiResponse | undefined
 */
const usePaymentMethod = () => {
  const { orgId } = useAuth();
  return useQuery({
    queryKey: [Query.StripeKeys.paymentMethod, { orgId }],
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get<ApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/${orgId}/payment-method`,
      );
      return response.data.paymentMethod;
    },
  });
};

export { usePaymentMethod };
